import { Box, Button, Grid, styled, Typography } from '@mui/material'
import React, { useRef } from 'react'
import IconBackground from '../Common/IconBackground';
import { businessTypeOption, useCommonStyles } from '../../utils';
import { BUCKET_URL } from '../../ApiSetUp/AuthApi';
import { standardDateFormat } from '../../lib/standardDateFormat';

const KeyName = styled('div')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'Satoshi-Light',
}));

const Answer = styled('div')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'Satoshi-Bold',
}));
const Title = styled(Typography)(({ theme }) => ({
    fontSize: "28px",
    fontFamily: "Satoshi-Bold",
    marginBottom: "20px",
    display: 'none',
    '@media print': {
        display: 'block',
    },
}));

const ViewVendorData = ({ setIsViewVendor, selectedVendorData }) => {
    // =============== Hooks ===============
    const { classes } = useCommonStyles();
    const componentRef = useRef();

    // =============== Handler ===============
    const handlePrint = () => {
        const printContent = componentRef.current.innerHTML;
        const originalContent = document.body.innerHTML;

        document.body.innerHTML = printContent;
        window.print();
        document.body.innerHTML = originalContent;
        window.location.reload();
    };
    const setBussinessTypeOption = selectedVendorData?.bussiness_type?.map((ele) => {
        return {
            id: ele,
            name: businessTypeOption?.find((item) => item?.id === ele)?.name
        }
    })

    return (
        <>
            <Grid container padding={"30px"} spacing={3} ref={componentRef}>
                <Title>Vendor Registration form</Title>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Vendor Type</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        {selectedVendorData?.vendorType?.length > 0 ?
                            selectedVendorData?.vendorType?.map((ele) =>
                                <Answer>{ele}</Answer>
                            )
                            :
                            <Answer>{"NA"}</Answer>
                        }
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Vendor Name</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedVendorData?.name || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Vendor Code</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedVendorData?.vendorCode || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Company name</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedVendorData?.companyName || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Contact Information</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedVendorData?.mobileNumber || "NA"}</Answer>
                        {selectedVendorData?.email &&
                            <Answer>{selectedVendorData?.email}</Answer>
                        }
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Address</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedVendorData?.address ? selectedVendorData?.address : "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>GST No</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedVendorData?.isGstNo ? selectedVendorData?.gstNumber : "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Document Uploads</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        {(!selectedVendorData?.MSMEDocument && !selectedVendorData?.GSTDocument) &&
                            <Answer>NA</Answer>
                        }
                        {selectedVendorData?.MSMEDocument &&
                            <Box display="flex" flexWrap={"wrap"} alignItems={"center"} gap={1}>
                                <Answer>MSME Certificate {selectedVendorData?.MSMEDocument?.split("/").pop()}</Answer>
                                <IconBackground icon="visibility" size='34px' onClick={() => window?.open(`${BUCKET_URL + selectedVendorData?.MSMEDocument}`)} />
                            </Box>
                        }
                        {selectedVendorData?.GSTDocument &&
                            <Box display="flex" flexWrap={"wrap"} alignItems={"center"} gap={1} mt={1}>
                                <Answer>GST Certificate {selectedVendorData?.GSTDocument?.split("/").pop()}</Answer>
                                <IconBackground icon="visibility" size='34px' onClick={() => window?.open(`${BUCKET_URL + selectedVendorData?.GSTDocument}`)} />
                            </Box>
                        }
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Business type</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        {setBussinessTypeOption?.map((ele) => {
                            return (
                                <Answer>{ele?.name}</Answer>
                            )
                        })}
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Grade D</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer sx={{ textTransform: "capitalize" }}>{`${selectedVendorData?.gradeD?.isYes} ${selectedVendorData?.gradeD?.isCritical == "nonCritical" ? "/ Non Critical" : "/ Critical"}`}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Criteria for Supplier</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        {selectedVendorData?.selectionCriteria ?
                            <Answer>{selectedVendorData?.selectionCriteria == "1" ? "On Basis of SCPL Past Experience" : selectedVendorData?.selectionCriteria == "2" ? "Sample Sent by Supplier" : "Any Other Reference"}</Answer>
                            :
                            <Answer>{"NA"}</Answer>
                        }
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Date</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>Received date : {selectedVendorData?.receivedDate ? standardDateFormat(selectedVendorData?.receivedDate) : "NA"}</Answer>
                        <Answer>Approved date : {selectedVendorData?.approvedDate ? standardDateFormat(selectedVendorData?.approvedDate) : "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Any other Reference</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedVendorData?.description || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Signature</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        {selectedVendorData?.approvalDetails?.signature ? (
                            <img
                                src={`data:image/png;base64,${selectedVendorData?.approvalDetails?.signature}`}
                                alt="Signature"
                                style={{ width: "150px", height: "auto" }}
                            />
                        )
                            : <Answer>NA</Answer>
                        }
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Vendor Blacklist</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedVendorData?.isBlackListed ? "Yes" : "No"}</Answer>
                    </Grid>
                </Grid>
                {selectedVendorData?.isBlackListed &&
                    <>
                        <Grid container item xs={12}>
                            <Grid item xs={3}>
                                <KeyName>Blacklist Date</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={8}>
                                <Answer>{selectedVendorData?.blackListDate ? standardDateFormat(selectedVendorData?.blackListDate) : "NA"}</Answer>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={3}>
                                <KeyName>Remark</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={8}>
                                <Answer>{selectedVendorData?.remark || "NA"}</Answer>
                            </Grid>
                        </Grid>
                    </>
                }
            </Grid>
            <Box display={"flex"} gap={2} padding={"30px"} pt={0}>
                <Button className={classes?.saveButton} onClick={handlePrint}>Print</Button>
                <Button className={classes?.cancelButton} onClick={() => setIsViewVendor(false)}>Cancel</Button>
            </Box>
        </>
    )
}

export default ViewVendorData